module.exports = __webpack_public_path__ + "static/media/logo-min.a7608728.png";